import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import {
  useGetVehicleListingDetailQuery,
  useUpdateVehicleListingMutation,
} from "store/services/vehicleListingApi";
import { useAppMeta } from "hooks";
import VehicleListingForm from "./vehicleListingComponents/VehicleListingForm";

const VehicleListingEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "External Driver Record", path: "/app/crm/vehicle-listing/list" },
    { title: "Edit External Driver Record" },
  ];

  const {
    data: vehicleListingDetail,
    isLoading: loadingVehicleListing,
    error,
  } = useGetVehicleListingDetailQuery(id);

  const [updateVehicleListing, { isLoading: updatingVehicleListing }] =
    useUpdateVehicleListingMutation();

  const handleUpdateVehicleListing = async (data) => {
    try {
      await updateVehicleListing({ _id: id, ...data }).unwrap();
      toast.success("External Driver Record successfully updated!");
      navigate(`/app/crm/vehicle-listing/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ??
        err?.message ??
        "Couldn't update External Driver Record!"
      );
    }
  };

  useAppMeta("Edit External Driver Record");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingVehicleListing || updatingVehicleListing}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <VehicleListingForm
          isBusy={loadingVehicleListing || updatingVehicleListing}
          vehicleListingDetail={vehicleListingDetail}
          onSubmit={handleUpdateVehicleListing}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VehicleListingEditScreen;